module.exports = __webpack_public_path__ + "img/4.d110eba2.png";